export default __webpack_public_path__ + "static/media/purple-x.fc9a8a9e.svg";